import React from "react";
import Switch from "react-switch";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";

const Output = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0.5em;
`;

const OutputWrapper = styled.div`
  min-width: 400px;
  margin: 1em;
`;

function ToggleBoxes(props) {
  // Sort outputs by POT_FREE_* number
  const sortedOutputs = [...props.outputConf].sort((a, b) => {
    const numA = parseInt(a.pcbName.replace("POT_FREE_", ""));
    const numB = parseInt(b.pcbName.replace("POT_FREE_", ""));
    return numA - numB;
  });

  // Create a mapping from sorted indexes to original indexes
  const sortedToOriginalIndex = sortedOutputs.map((sortedItem) =>
    props.outputConf.findIndex(
      (originalItem) => originalItem.pcbName === sortedItem.pcbName,
    ),
  );

  return (
    <OutputWrapper>
      <h3>{props.title}</h3>
      {sortedOutputs.map((output, sortedIndex) => {
        // Get the original index for the handleChange function
        const originalIndex = sortedToOriginalIndex[sortedIndex];

        return (
          <Output key={sortedIndex}>
            <span data-tip={output.pcbName}>{output.name}</span>
            <Switch
              onChange={() => props.handleChange(originalIndex)}
              checked={output.value ? true : false}
              width={100}
              disabled={props.readOnly ? false : true}
              uncheckedIcon={
                <div
                  style={{
                    marginLeft: "-1.1em",
                    paddingTop: "0.3em",
                  }}
                >
                  opened
                </div>
              }
              checkedIcon={
                <div
                  style={{
                    marginLeft: "1em",
                    paddingTop: "0.3em",
                  }}
                >
                  closed
                </div>
              }
            />
          </Output>
        );
      })}

      <ReactTooltip place="left" type="info" effect="solid" />
    </OutputWrapper>
  );
}

export default ToggleBoxes;
